export const config = {
    SERVER_URL: process.env.REACT_APP_SERVER_URL,
    APP_URL: process.env.REACT_APP_URL,
    ASSETS_URL: process.env.REACT_APP_ASSETS_URL,
    WS_URL: process.env.REACT_APP_WS_URL,
    DASHBOARD_URL: process.env.REACT_APP_DASHBOARD_URL,
}
